/**
 * Convert a km distance string to show both km and miles.
 * Handles formats like "71,000 km/year", "11,000 km non-stop", "500 km", "8 km", etc.
 * Returns: "71,000 km (44,117 mi) /year" or "500 km (311 mi)"
 */
export function kmToMiles(distanceStr) {
  if (!distanceStr) return distanceStr;

  // Extract the numeric km value (handles commas)
  const match = distanceStr.match(/([\d,]+)\s*km/i);
  if (!match) return distanceStr;

  const kmStr = match[1];
  const km = parseFloat(kmStr.replace(/,/g, ''));
  const miles = Math.round(km * 0.621371);
  const milesFormatted = miles.toLocaleString();

  // Replace "X km" with "X km (Y mi)" in the original string
  return distanceStr.replace(
    /([\d,]+)\s*km/i,
    `${kmStr} km (${milesFormatted} mi)`
  );
}
